import radical from "../../image/originals/radical/free.webp"

import Collection from "./Collection";

const RadicalCollection = () => {
  const title = "FREE RADICALS";

  const items = [
    {
      title: "Reena Rose",
      imageUrl: radical,
      projectUrl: "/ReenaRose",
    },
  ];

  return (
    <Collection
      items={items}
      title={title}
      variant="boutique"
      eyebrow="Original Paintings"
      pageClassName="collection-page--original-paintings"
      showFooter
    />
  );
};

export default RadicalCollection;
